module.exports = "/_next/static/images/4fddcbfb1787a000ac9547ab23e5c8e9-Nubank_HickDuarte_59058 1_xs.png";